<ix-content-header slot="header" header-title="Masterfile Management"> </ix-content-header>
<div>
  <ix-layout-grid>
    <ix-row>
      <ix-button (click)="downloadMasterFile()">Download</ix-button>
    </ix-row>
    <ix-row>
      <ix-upload
        accept=".xls,.xlsx"
        (filesChanged)="onMasterFileChanged($event)"
        [selectFileText]="selectMasterFileText"
        i18nUploadFile="Select Masterfile..."
      >
      </ix-upload>
      <ix-button (click)="uploadMasterfile()" [disabled]="masterFileToUpload === undefined"
        >Upload Masterfile</ix-button
      >
    </ix-row>
  </ix-layout-grid>
</div>
